// test2162
(2162 && 0);
